import { Controller } from "@hotwired/stimulus"

// One shared frame per navigation. Preview snapshots must not start requests.
export default class extends Controller {
  static values = { src: String }

  connect() {
    this.load()
  }

  load() {
    if (this.loaded || document.documentElement.hasAttribute("data-turbo-preview")) return
    this.loaded = true
    this.element.src = this.srcValue
  }

  publish() {
    this.dispatch("changed", {
      prefix: "live-schedule",
      target: window,
      detail: JSON.parse(this.element.firstElementChild.dataset.liveSchedule)
    })
  }

  reset() {
    this.loaded = false
    this.element.removeAttribute("src")
    this.element.removeAttribute("complete")
    this.element.replaceChildren()
  }
}
